import { Location } from "gen/company/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { TODAY_PRESET } from "shared-ts/libs/dates/presets"
import { TimestampRange } from "shared-ts/libs/dates/timestampRange"
import { QueryParams, WebUrl } from "shared-web/lib/webUrl"

import { encodeQueryParam } from "hooks/filters/useWebFilter"

export function cashManagement(
  location?: Pick<Location, "id" | "name">
): WebUrl {
  const query: QueryParams = {}

  if (location !== undefined) {
    query.location = encodeQueryParam(
      {
        key: UUID.idString(location.id),
        value: location.name,
      },
      true
    )
  }

  const todayTimestampRange = TODAY_PRESET.rangeFunc()?.toTimestampRangePB()
  if (todayTimestampRange) {
    query.date = TimestampRange.toQueryParam(todayTimestampRange)
  }

  return {
    pathname: "/pos/cash-management",
    query,
  }
}
